module.exports = __webpack_public_path__ + "static/medograf-extraimg2@2x-min-046520fb878c5935df0800dadf203ce4.png";